import {
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  REGISTER_FAIL,
} from "../actionTypes";

import { LOGOUT_REQUEST, LOGOUT_SUCCESS, LOGOUT_FAIL } from "../actionTypes";
import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAIL } from "../actionTypes";
import {
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  UPDATE_USER_RESET,
  UPDATE_PASSWORD_REQUEST,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_FAIL,
} from "../actionTypes";
import {
  FETCH_DEALERS_REQUEST,
  FETCH_DEALERS_SUCCESS,
  FETCH_DEALERS_FAIL,
} from "../actionTypes";
import {
  FETCH_ADMINDET_REQUEST,
  FETCH_ADMINDET_SUCCESS,
  FETCH_ADMINDET_FAIL,
} from "../actionTypes";
import {
  UPDATE_ADMINDET_REQUEST,
  UPDATE_ADMINDET_SUCCESS,
  UPDATE_ADMINDET_FAIL,
} from "../actionTypes";
import {
  UPDATE_DEALER_STATUS_REQUEST,
  UPDATE_DEALER_STATUS_SUCCESS,
  UPDATE_DEALER_STATUS_FAIL,
} from "../actionTypes";
import {
  SHARE_CREDENTIALS_REQUEST,
  SHARE_CREDENTIALS_SUCCESS,
  SHARE_CREDENTIALS_FAIL,
} from "../actionTypes";
import {
  FETCH_CLIENT_REPORT_REQUEST,
  FETCH_CLIENT_REPORT_SUCCESS,
  FETCH_CLIENT_REPORT_FAILURE,
} from "../actionTypes";
const initialState = {
  loading: false,
  userInfo: localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null,
  error: null,
  updateSuccess: false,
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER_REQUEST:
    case LOGIN_REQUEST:
    case LOGOUT_REQUEST:
    case UPDATE_USER_REQUEST:
    case UPDATE_PASSWORD_REQUEST:
      return {
        ...state,

        loading: true,
        updateSuccess: false,
        // userInfo: action.payload,
      };
    case REGISTER_SUCCESS:
    case LOGIN_SUCCESS:
    case LOGOUT_SUCCESS:
    case UPDATE_USER_SUCCESS:
    case UPDATE_PASSWORD_SUCCESS:
      const updatedUserInfo = {
        ...state.userInfo,
        ...action.payload,
      };
      localStorage.setItem("userInfo", JSON.stringify(updatedUserInfo));
      return {
        ...state,
        loading: false,
        userInfo: updatedUserInfo,
        updateSuccess: true,
      };
    // return {
    //   ...state,
    //   loading: false,
    //   userInfo: action.payload,
    //   updateSuccess: true,
    // };
    case REGISTER_FAIL:
    case LOGIN_FAIL:
    case LOGOUT_FAIL:
    case UPDATE_USER_FAIL:
    case UPDATE_PASSWORD_FAIL:
      return {
        // ...state,
        // loading: false,
        // error: action.payload,
        // updateSuccess: false,
        ...state,
        loading: false,
        error: action.payload,
        updateSuccess: false,
      };
    case UPDATE_USER_RESET:
      return {
        ...state,
        updateSuccess: false,
      };

    default:
      return state;
  }
};
const initialStated = {
  loading: false,
  dealers: [],
  error: null,
};
export const dealerListReducer = (state = initialStated, action) => {
  switch (action.type) {
    case FETCH_DEALERS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_DEALERS_SUCCESS:
      return {
        loading: false,
        dealers: action.payload, //  this must be correct
        error: null,
      };
    case FETCH_DEALERS_FAIL:
      return {
        loading: false,
        dealers: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
const initialAdminState = {
  loading: false,
  admin: null,
  isEditable: false,
  error: null,
  updateLoading: false,
  updateSuccess: false,
  updateError: null,
};
export const dealerStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_DEALER_STATUS_REQUEST:
      return { ...state, loading: true, success: false, error: null };
    case UPDATE_DEALER_STATUS_SUCCESS:
      return { ...state, loading: false, success: true, error: null };
    case UPDATE_DEALER_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
export const adminListReducer = (state = initialAdminState, action) => {
  switch (action.type) {
    case FETCH_ADMINDET_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_ADMINDET_SUCCESS:
      return {
        ...state,
        loading: false,
        admin: action.payload.data,
        isEditable: action.payload.is_editable,
        error: null,
      };
    case FETCH_ADMINDET_FAIL:
      return {
        ...state,
        loading: false,
        admin: null,
        isEditable: false,
        error: action.payload,
      };

    case UPDATE_ADMINDET_REQUEST:
      return {
        ...state,
        updateLoading: true,
        updateSuccess: false,
        updateError: null,
      };
    case UPDATE_ADMINDET_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        updateSuccess: true,
        admin: action.payload.data,
      };
    case UPDATE_ADMINDET_FAIL:
      return {
        ...state,
        updateLoading: false,
        updateSuccess: false,
        updateError: action.payload,
      };

    default:
      return state;
  }
};
export const dealerShareCredentialsReducer = (state = {}, action) => {
  switch (action.type) {
    case SHARE_CREDENTIALS_REQUEST:
      return { loading: true };
    case SHARE_CREDENTIALS_SUCCESS:
      return { loading: false, success: true };
    case SHARE_CREDENTIALS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
export const clientReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CLIENT_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_CLIENT_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload, // data.data from API (array)
      };
    case FETCH_CLIENT_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
// src/features/auth/authSlice.js

export default authReducer;
